// extracted by mini-css-extract-plugin
export default {"filterBtn":"filter-button_filterBtn__+Leq6","label":"filter-button_label__WmIsR"};